import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=0f8716a1&scoped=true&"
import script from "./order-details.vue?vue&type=script&lang=js&"
export * from "./order-details.vue?vue&type=script&lang=js&"
import style0 from "./order-details.vue?vue&type=style&index=0&id=0f8716a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8716a1",
  null
  
)

export default component.exports